/* PD Tailles : logique partagée « hauteur de l'enfant → taille conseillée »
   (outil du guide des tailles de la fiche produit, Dressing de Princesse).
   Entre deux tailles : la taille au-dessus. Taille du tableau absente de la robe : la plus proche proposée. */
(function () {
  if (window.PdSize) return;

  const parseRange = (text) => {
    const nums = (text || '').replace(',', '.').match(/\d+(\.\d+)?/g);
    if (!nums) return null;
    const values = nums.map(Number);
    return { min: Math.min(...values), max: Math.max(...values) };
  };

  // Âge en années à partir d'un libellé (« 3-4 ans », « 18 mois »)
  const parseAge = (text) => {
    const lower = (text || '').toLowerCase();
    const range = parseRange(lower);
    if (!range) return null;
    if (lower.includes('mois')) return { min: range.min / 12, max: range.max / 12 };
    return range;
  };

  const normalize = (text) => (text || '').toLowerCase().replace(/\s+/g, '').replace(/–|—/g, '-');

  // Colonne « hauteur » d'un guide custom.guide_tailles (mêmes mots-clés que snippets/pd-fp-guide.liquid)
  const heightColumn = (columns) =>
    (columns || []).findIndex((col) => {
      const lower = String(col).toLowerCase();
      return ['hauteur', 'stature', "taille de l'enfant", 'taille de l’enfant', 'taille enfant', 'taille bébé'].some((key) => lower.includes(key));
    });

  // Tableau par défaut âge → taille de l'enfant (identique à snippets/pd-fp-guide.liquid)
  const DEFAULT_ROWS = [
    ['2 ans', '86-92'], ['3 ans', '92-98'], ['4 ans', '98-104'], ['5 ans', '104-110'], ['6 ans', '110-116'],
    ['7 ans', '116-122'], ['8 ans', '122-128'], ['9 ans', '128-134'], ['10 ans', '134-140'], ['11 ans', '140-146'],
    ['12 ans', '146-152'], ['13 ans', '152-158'], ['14 ans', '158-164'],
  ];

  // Lignes { label, range } d'un guide JSON, ou du tableau par défaut si le guide est absent
  const rowsFromGuide = (guide) => {
    const columns = guide && guide.colonnes;
    const lines = guide && guide.lignes;
    if (!columns || !lines || !columns.length || !lines.length) {
      return DEFAULT_ROWS.map(([label, range]) => ({ label, range: parseRange(range) }));
    }
    const col = heightColumn(columns);
    if (col < 0) return [];
    return lines.map((line) => ({ label: String(line[0]).trim(), range: parseRange(line[col] && String(line[col])) })).filter((row) => row.range);
  };

  /* Ligne du tableau pour une hauteur. status : result | between | below | above ; null si hauteur invalide */
  function recommend(rows, height) {
    if (!height || height < 40 || height > 190 || !rows.length) return null;
    const containing = rows.filter((row) => height >= row.range.min && height <= row.range.max);
    if (containing.length > 1) return { row: containing[containing.length - 1], status: 'between' };
    if (containing.length === 1) return { row: containing[0], status: 'result' };
    if (height < rows[0].range.min) return { row: rows[0], status: 'below' };
    if (height > rows[rows.length - 1].range.max) return { row: rows[rows.length - 1], status: 'above' };
    return { row: rows.find((r) => r.range.min > height) || rows[rows.length - 1], status: 'between' };
  }

  /* Index de la taille de la robe correspondant au libellé du tableau (exact, tranche d'âge contenante, au-dessus), -1 sinon */
  function matchSize(label, sizes) {
    const exact = sizes.findIndex((size) => normalize(size) === normalize(label));
    if (exact > -1) return exact;
    const age = parseAge(label);
    if (!age) return -1;
    const withAge = sizes.map((size, index) => ({ index, age: parseAge(size) })).filter((x) => x.age);
    const containing = withAge.find((x) => age.max >= x.age.min && age.max <= x.age.max);
    if (containing) return containing.index;
    const above = withAge.filter((x) => x.age.min >= age.max).sort((a, b) => a.age.min - b.age.min)[0];
    return above ? above.index : -1;
  }

  /* Taille du tableau hors des tailles de la robe : la plus grande (above) ou la plus petite (below), sinon null */
  function fallbackSize(label, sizes) {
    const rowAge = parseAge(label);
    const withAge = sizes.map((size, index) => ({ index, age: parseAge(size) })).filter((x) => x.age);
    if (!rowAge || !withAge.length) return null;
    withAge.sort((a, b) => a.age.max - b.age.max);
    if (rowAge.min > withAge[withAge.length - 1].age.max) return { index: withAge[withAge.length - 1].index, status: 'above' };
    if (rowAge.max < withAge[0].age.min) return { index: withAge[0].index, status: 'below' };
    return null;
  }

  /* Tout en une fois : { status, rowLabel, index } (index -1 : taille absente) ou null si hauteur invalide */
  function sizeForHeight(rows, sizes, height) {
    const found = recommend(rows, height);
    if (!found) return null;
    let status = found.status;
    let index = sizes.length ? matchSize(found.row.label, sizes) : -1;
    if (sizes.length && index < 0) {
      const fallback = fallbackSize(found.row.label, sizes);
      if (fallback) {
        index = fallback.index;
        status = fallback.status;
      }
    }
    return { status, row: found.row, rowLabel: found.row.label, index };
  }

  window.PdSize = { parseRange, parseAge, normalize, heightColumn, rowsFromGuide, recommend, matchSize, fallbackSize, sizeForHeight };
})();
